<template>
    <v-tooltip bottom v-if="!!storeAction">
      <template v-slot:activator="{ on }">
        <v-btn
            v-on="on"
            v-bind="$attrs"
            @click="onAction()"
            :disabled="disabled || isLoad()"
        >
          <v-icon>{{ icon }}</v-icon>
          {{ label }}
          <v-progress-circular
              v-show="isLoad()"
              indeterminate
              size="16"
              width="1"
              color="blue-grey lighten-1"
              class="ml-1 mr-n2"
          >
          </v-progress-circular>
        </v-btn>
      </template>
      <span v-if="!!text">{{ text }}</span>
      <span v-else>{{ label }}</span>
    </v-tooltip>
</template>

<script>

import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useActionStore} from "@/components/Common/CommonBtnActionGroup";

export default {
  name: 'CommonBtnAction',
  inheritAttrs: false,
  props: {
    icon: {default: null},
    text: {default: null},
    label: {default: null},
    actionName: {default: null},
    actionUid: {default() {return uuidv4()}},
    disabled: {default: true},
    storeName: {type: [String], default: null},
    dtoActionCommand: {type: [String], default: null},
    uidItem: {default: null},
    uidSelected: {default() {return []}},
    data: {default: null},
  },

  components: {},

  computed: {},

  methods: {
    onAction() {
      console.log('onAction')
      this.storeAction.actionsUid[this.actionUid] = {load: true}
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: this.uidItem,
        uidSelected: this.uidSelected,
        actionName: this.actionName,
        actionUid: this.actionUid,
        data: this.data,
        callBack: null,
      })
    },
    isLoad() {
      let action_state = this.storeAction.actionsUid[this.actionUid]
      if (!!action_state)
        return action_state.load
    },
  },

  async mounted() {
    this.storeAction = useActionStore()()
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeAction: null,
      storeAggregate: null,
    }
  }
}
</script>

